import {saveAs} from "file-saver";

export class DownloadFile {

    constructor(el) {
        this.el = el;
        this.href = this.el.getAttribute("href");
        this.title = this.el.innerText;
        this.extention = this.href.split(".").pop();
        this.init();
    }

    init() {
        this.el.addEventListener("click", (e) => {
            e.preventDefault();
            saveAs(this.href, this.title + "." + this.extention);
            return false;
        });
    }
}

document.querySelectorAll(".js-download-file").forEach(elem => new DownloadFile(elem));
